<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.freeze"
      @keydown.esc="dialog.freeze = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Freeze Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in configHeaders" 
                        :key="index"
                        class="px-0"
                        @click="item.freeze = !item.freeze ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.freeze">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.freeze ? 'font-weight-bold' : ''"
                            :style="item.freeze ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Freeze
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.hide"
      @keydown.esc="dialog.hide = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hide Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.hide = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in headers" 
                        :key="index"
                        class="px-0"
                        @click="item.hide = !item.hide ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.hide">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.hide ? 'font-weight-bold' : ''"
                            :style="item.hide ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Hide
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="900"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          {{ form.id === '' ? 'Tambah' : 'Ubah' }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <ValidationProvider 
                name="title" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Judul
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. Admin"

                  v-uppercase

                  v-model="form.title"
                  :success="form.title !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 70%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Judul {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.title !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <div>
                <div class="fs-12 font_weight_600 black_one label-input mb-2">
                  Hak Akses
                </div>

                <div
                  style="height: calc(100vh - 400px); overflow-y: auto;">
                  <div v-for="(item, index) in data_menu" :key="index">
                    <v-checkbox hide-details :value="item.id" v-model="form.menu_arr" v-if="item.title !== 'Konfigurasi'">
                      <template v-slot:label>
                        <div class="d-flex align-center">
                          <v-icon size="18">{{ item.icon }}</v-icon>
                          <div class="black--text ml-2 fs-14">{{ item.title }}</div>
                        </div>
                      </template>
                    </v-checkbox>
                    <div v-if="item.title !== 'Konfigurasi'">
                      <div v-if="Object.keys(item.action).length > 0">
                        <div v-if="item.id === 2" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 2 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 2 }).length < 1 ? '' : 'black--text'">
                                Tambah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 2 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 2 }).length < 1 ? '' : 'black--text'">
                                Ubah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 2 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 2 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                        </div>  

                        <div v-if="item.id === 3" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.detail" :disabled="form.menu_arr.filter(function(v) { return v === 3 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 3 }).length < 1 ? '' : 'black--text'">
                                Detail
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 3 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 3 }).length < 1 ? '' : 'black--text'">
                                Tambah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 3 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 3 }).length < 1 ? '' : 'black--text'">
                                Ubah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 3 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 3 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.aktif" :disabled="form.menu_arr.filter(function(v) { return v === 3 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 3 }).length < 1 ? '' : 'black--text'">
                                Aktif & Tidak Aktif
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 3 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 3 }).length < 1 ? '' : 'black--text'">
                                Export
                              </div>
                            </template>
                          </v-checkbox>
                        </div>

                        <div v-if="item.id === 4" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.detail" :disabled="form.menu_arr.filter(function(v) { return v === 4 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 4 }).length < 1 ? '' : 'black--text'">
                                Detail
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 4 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 4 }).length < 1 ? '' : 'black--text'">
                                Tambah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 4 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 4 }).length < 1 ? '' : 'black--text'">
                                Ubah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 4 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 4 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.aktif" :disabled="form.menu_arr.filter(function(v) { return v === 4 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 4 }).length < 1 ? '' : 'black--text'">
                                Aktif & Tidak Aktif
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 4 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 4 }).length < 1 ? '' : 'black--text'">
                                Export
                              </div>
                            </template>
                          </v-checkbox>
                        </div> 

                        <div v-if="item.id === 13" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.detail" :disabled="form.menu_arr.filter(function(v) { return v === 13 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 13 }).length < 1 ? '' : 'black--text'">
                                Detail
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 13 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 13 }).length < 1 ? '' : 'black--text'">
                                Tambah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 13 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 13 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                        </div>

                        <div v-if="item.id === 19" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 19 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 19 }).length < 1 ? '' : 'black--text'">
                                Ubah
                              </div>
                            </template>
                          </v-checkbox>
                        </div>

                        <div v-if="item.id === 14" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                Tambah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                Ubah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                        </div> 

                        <div v-if="item.id === 15" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.detail" :disabled="form.menu_arr.filter(function(v) { return v === 15 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 15 }).length < 1 ? '' : 'black--text'">
                                Detail
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 15 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 15 }).length < 1 ? '' : 'black--text'">
                                Tambah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 15 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 15 }).length < 1 ? '' : 'black--text'">
                                Ubah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 15 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 15 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                        </div> 

                        <div v-if="item.id === 16" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 16 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 16 }).length < 1 ? '' : 'black--text'">
                                Tambah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 16 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 16 }).length < 1 ? '' : 'black--text'">
                                Ubah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 16 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 16 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                        </div> 

                        <div v-if="item.id === 17" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 17 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 17 }).length < 1 ? '' : 'black--text'">
                                Tambah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.detail" :disabled="form.menu_arr.filter(function(v) { return v === 17 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 17 }).length < 1 ? '' : 'black--text'">
                                Detail
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.preview" :disabled="form.menu_arr.filter(function(v) { return v === 17 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 17 }).length < 1 ? '' : 'black--text'">
                                Preview
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 17 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 17 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.template" :disabled="form.menu_arr.filter(function(v) { return v === 17 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 17 }).length < 1 ? '' : 'black--text'">
                                Template
                              </div>
                            </template>
                          </v-checkbox>
                        </div> 

                        <div v-if="item.id === 18" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 18 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 18 }).length < 1 ? '' : 'black--text'">
                                Tambah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 18 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 18 }).length < 1 ? '' : 'black--text'">
                                Ubah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 18 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 18 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                        </div> 
                        
                        <div v-if="item.id === 5" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 5 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 5 }).length < 1 ? '' : 'black--text'">
                                Tambah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 5 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 5 }).length < 1 ? '' : 'black--text'">
                                Ubah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 5 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 5 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                        </div>
                        <div v-if="item.id === 9" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 9 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 9 }).length < 1 ? '' : 'black--text'">
                                Tambah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 9 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 9 }).length < 1 ? '' : 'black--text'">
                                Ubah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 9 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 9 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                        </div>  
                        <div v-if="item.id === 10" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 10 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 10 }).length < 1 ? '' : 'black--text'">
                                Tambah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 10 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 10 }).length < 1 ? '' : 'black--text'">
                                Ubah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 10 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 10 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                        </div>  

                        <div v-if="item.id === 11" class="ml-5 d-flex align-center fs-12">
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 11 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 11 }).length < 1 ? '' : 'black--text'">
                                Ubah
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 11 }).length < 1">
                            <template v-slot:label>
                              <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 11 }).length < 1 ? '' : 'black--text'">
                                Hapus
                              </div>
                            </template>
                          </v-checkbox>
                        </div>  
                      </div>

                      
                    </div>
                    <!-- <div v-if="item.title === 'Konfigurasi'">
                      <div class="mt-4">
                        Konfigurasi
                      </div>
                      <div v-for="(l, k) in item.sub_menu" :key="k">
                        <v-checkbox hide-details :value="l.id" v-model="form.menu_arr">
                          <template v-slot:label>
                            <div class="d-flex align-center">
                              <v-icon size="18">{{ l.icon }}</v-icon>
                              <div class="black--text ml-2 fs-14">{{ l.title }}</div>
                            </div>
                          </template>
                        </v-checkbox>
                        <div v-if="Object.keys(l.action).length > 0">
                          <div v-if="item.id === 8" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 8 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 8 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 8 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 8 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 8 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 8 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                          </div>  
                          <div v-if="item.id === 9" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 9 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 9 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 9 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 9 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 9 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 9 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                          </div>  
                          <div v-if="item.id === 10" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 10 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 10 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 10 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 10 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 10 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 10 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                          </div>  
                        </div>
                      </div>
                    </div>   -->
                  </div>
                </div>
              </div>
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-center">
              <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hapus Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row
      class="pa-4 pr-1">
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; border-radius: 10px;">
          <v-card-text>
            <v-row>
              <v-col 
                cols="12" 
                md="8" 
                class="d-flex align-center">
                <div class="mr-3">
                  <v-btn v-if="hak_akses_menu.action.add"
                    elevation="0"
                    style="background: #4caf5033; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center green--text"
                    @click="dialog.form = true; reset();">
                    <v-icon size="18">mdi-plus-circle-outline</v-icon>

                    <span class="ml-1">
                      Tambah
                    </span>
                  </v-btn>
                </div>

                <div v-if="selected.row.length === 1 && hak_akses_menu.action.update"
                  class="mr-3" >
                  <v-btn 
                    elevation="0"
                    style="background: #2196f333; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                    @click="dialog.form = true; reset(selected.row[0]);">
                    <v-icon size="18">mdi-circle-edit-outline</v-icon>

                    <span class="ml-1">
                      Ubah
                    </span>
                  </v-btn>
                </div>

                <div v-if="selected.row.length > 0 && hak_akses_menu.action.delete"
                  class="mr-3" >
                  <v-btn
                    elevation="0"
                    style="background: #f4403433; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                    @click="toDelete()">
                    <v-icon size="18">mdi-delete-circle-outline</v-icon>

                    <span class="ml-1">
                      Hapus
                    </span>
                  </v-btn>
                </div>
              </v-col>
                
              <v-col 
                cols="12" 
                md="4" 
                class="d-flex align-center justify-end">
                <v-text-field
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  placeholder="Cari . . ."
                  append-icon="mdi-magnify"
                  clearable

                  v-uppercase

                  v-model="search"
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  style="border-radius: 10px;">
                </v-text-field>

                <!-- FREEZE COLUMN -->
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        :color="set_color"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div>

                <!-- HIDE COLUMN -->
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            mobile-breakpoint="0"
            class="table-grid"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '265px' : '193px'})`"
            :show-select="checkbox"
            :single-select="true"
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="configHeaders"
            :items="list"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            @dblclick:row="doubleClick"
            hide-default-footer>
            <template
              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
              v-slot:[`item.${header.value}`]="{ value }">
              <div
                v-bind:key="header.value">
                <div v-if="header.format !== 'array'">
                  {{ rowFormat(header.format, value) }} 
                </div>

                <div v-if="header.format === 'array'">
                  <v-chip
                    v-for="(item, index) in value"
                    :key="index"
                    class="mr-1 my-1"
                    color="primary"
                    small>
                    {{ item.title }}
                  </v-chip>
                </div>
              </div>  
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ lastIndex + index }}
            </template>

            <v-progress-linear 
              v-show="process.load" 
              slot="progress" 
              color="white" 
              indeterminate>
            </v-progress-linear>
          </v-data-table>

          <pagination v-if="pagination.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)" 
            :model="pagination" :display="paginationList"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,
          form: false,
          delete: false,

          attachment: false,
          map: false
        },
        search: '',
        selected: {
          row: [],
          freeze: [],
          delete: []
        },

        data_menu: [
          {
            id: 1,
            title: 'Dashboard',
            icon: 'mdi-view-dashboard-outline',
            link: '/dashboard',
            active: true,
            sub_menu: [],
            action: {}
          },
          {
            id: 12,
            title: 'Dashboard Sentana',
            icon: 'mdi-view-dashboard-outline',
            link: '/dashboard-sentana',
            active: true,
            sub_menu: [],
            action: {}
          },
          {
            id: 2,
            title: 'Struktur Organisasi',
            icon: 'mdi-abacus',
            link: '/unit',
            active: false,
            sub_menu: [],
            action: {
              add: false,
              update: false,
              delete: false
            }
          },
          {
            id: 3,
            title: 'Abdi Dalem',
            icon: 'mdi-account-supervisor-outline',
            link: '/officer',
            active: false,
            sub_menu: [],
            action: {
              add: false,
              update: false,
              delete: false,
              aktif: false,
              detail: false,
              export: false
            }
          },
          {
            id: 4,
            title: 'Sentana',
            icon: 'mdi-account-multiple',
            link: '/sentana',
            active: false,
            sub_menu: [],
            action: {
              add: false,
              update: false,
              delete: false,
              aktif: false,
              detail: false,
              export: false
            }
          },
          {
            id: 13,
            title: 'Data Pesan',
            icon: 'mdi-message-text',
            link: '/pesan/data',
            active: false,
            sub_menu: [],
            action: {
              add: false,
              detail: false,
              delete: false
            }
          },
          {
            id: 19,
            title: 'QR Image',
            icon: 'mdi-qrcode',
            link: '/pesan/qr',
            active: false,
            sub_menu: [],
            action: {
              update: false
            }
          },
          {
            id: 14,
            title: 'Kontak',
            icon: 'mdi-card-account-phone',
            link: '/pesan/kontak',
            active: false,
            sub_menu: [],
            action: {
              add: false,
              delete: false,
              update: false
            }
          },
          {
            id: 15,
            title: 'Grup',
            icon: 'mdi-home-group',
            link: '/pesan/grup',
            active: false,
            sub_menu: [],
            action: {
              add: false,
              detail: false,
              update: false,
              delete: false
            }
          },
          {
            id: 16,
            title: 'Kop Undangan',
            icon: 'mdi-file-document',
            link: '/undangan/kop',
            active: false,
            sub_menu: [],
            action: {
              add: false,
              update: false,
              delete: false
            }
          },
          {
            id: 17,
            title: 'Data Undangan',
            icon: 'mdi-file-document',
            link: '/undangan/data',
            active: false,
            sub_menu: [],
            action: {
              add: false,
              preview: false,
              delete: false,
              template: false,
              detail: false
            }
          },
          {
            id: 18,
            title: 'Kawedanan Undangan',
            icon: 'mdi-file-document',
            link: '/undangan/kepaniteraan',
            active: false,
            sub_menu: [],
            action: {
              add: false,
              update: false,
              delete: false
            }
          },
          {
            id: 5,
            title: 'Pencatatan',
            icon: 'mdi-finance',
            link: '/report',
            active: false,
            sub_menu: [],
            action: {
              add: false,
              update: false,
              delete: false
            }
          },
          {
            id: 6,
            title: 'Audit Trail',
            icon: 'mdi-monitor-account',
            link: '/audit',
            active: false,
            sub_menu: [],
            action: {}
          },
          {
            id: 8,
            title: 'Aplikasi',
            icon: 'mdi-cog-outline',
            link: '/konfigurasi/setting',
            active: false,
            sub_menu: [],
            action: {}
          },
          {
            id: 9,
            title: 'Data Trah',
            icon: 'mdi-account-group-outline',
            link: '/konfigurasi/trah/data',
            active: false,
            sub_menu: [],
            action: {
              add: false,
              update: false,
              delete: false
            }
          },
          {
            id: 10,
            title: 'Hak Akses',
            icon: 'mdi-folder-key',
            link: '/konfigurasi/hak-akses',
            active: false,
            sub_menu: [],
            action: {
              add: false,
              update: false,
              delete: false
            }
          },
          {
            id: 11,
            title: 'Hak Akses User',
            icon: 'mdi-account-key-outline',
            link: '/konfigurasi/hak-akses-user',
            active: false,
            sub_menu: [],
            action: {
              update: false,
              delete: false
            }
          }
        ],

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },
        markers: [],
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 15,
            height: -10
          }
        },

        options: {},
        headers: [],
        list: [],
        category: [],
        user: [],
        pagination: {},
        lastIndex: 0,
        limit: 20,

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },

        autocomplete: {
          user: ''
        },
        
        upload: {
          folder: null
        },

        picker: false,
        form: {
          id: '',
          title: '',
          menu_arr: []
        },
        paginationList: {},
        process: {
          load: false,
          form: false,
          image: false,
          category: false,
          user: false,
          delete: false,
          print: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      user_logs () {
        return this.$store.state.user
      },

      hak_akses_menu () {
        let menu = {}
        this.$store.state.menu.map(item => {
          if (item.id === 10) {
            menu = item
          }
        })
        return menu
      },

      rps() {
        return this.$vuetify.breakpoint.name
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },

      set_filter () {
        return this.$store.state.filter
      }
    },
    watch: {
      'options': {
        handler () {
          let pages = 1

          if (this.set_filter.length > 0 && Object.keys(this.objectFine()).length > 0) {
            this.limit = parseInt(this.objectFine().limit)
            pages = this.objectFine().page
            this.options.sortBy[0] = this.objectFine().sort
            this.options.sortDesc[0] = this.objectFine().order_by === 'ASC' ? true : false
            this.search = this.objectFine().search
          }
          
          // let pagination = { row: this.limit, page: 1 }

          let pagination = { row: this.limit, page: pages }

          this.fetch(pagination)
        },
        deep: true
      },
      'form.menu_arr': function(val) {
        val.filter(function(v) {
          return v === 2
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 2) {
            l.action = {
              add: false,
              update: false,
              delete: false
            }
          }
        }) : ''
        val.filter(function(v) {
          return v === 3
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 3) {
            l.action = {
              add: false,
              update: false,
              delete: false,
              aktif: false,
              export: false
            }
          }
        }) : ''
        val.filter(function(v) {
          return v === 4
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 4) {
            l.action = {
              add: false,
              update: false,
              delete: false,
              aktif: false,
              export: false
            }
          }
        }) : ''
        val.filter(function(v) {
          return v === 5
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 5) {
            l.action = {
              add: false,
              update: false,
              delete: false
            }
          }
        }) : ''
        val.filter(function(v) {
          return v === 9
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 9) {
            l.action = {
              add: false,
              update: false,
              delete: false
            }
          }
        }) : ''
        val.filter(function(v) {
          return v === 10
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 10) {
            l.action = {
              add: false,
              update: false,
              delete: false
            }
          }
        }) : ''
        val.filter(function(v) {
          return v === 11
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 11) {
            l.action = {
              update: false,
              delete: false
            }
          }
        }) : ''


        val.filter(function(v) {
          return v === 13
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 13) {
            l.action = {
              add: false,
              detail: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 14
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 14) {
            l.action = {
              add: false,
              delete: false,
              update: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 15
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 15) {
            l.action = {
              add: false,
              detail: false,
              update: false,
              delete: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 16
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 16) {
            l.action = {
              add: false,
              update: false,
              delete: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 17
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 17) {
            l.action = {
              add: false,
              preview: false,
              delete: false,
              template: false,
              detail: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 18
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 18) {
            l.action = {
              add: false,
              update: false,
              delete: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 19
        }).length < 1 ? this.data_menu.map(function(l) {
          if (l.id === 19) {
            l.action = {
              update: false
            }
          }
        }) : ''
      },
      'autocomplete.user': function() {
        this.fetchUser()
      },
      'form.user_id': function() {
        let t = this
        let users = this.user.filter(function(v) {
          return t.form.user_id == v.id
        })

        if (users.length > 0) {
          this.form.user_name = users[0].name.length < 1 ? '-' : users[0].name
        }
      },
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.image = this.upload.folder.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD DOC
              
              this.form.attachment = this.upload.folder.fileuri
            }
          }
        },
        deep: true
      },
    },
    mounted () {
      
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value.split('.')[0]
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          },00`
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          // data = value.length > 0 ? moment(value).format(format === 'date' ? 'D MMM, YYYY' : format === 'time' ? 'HH:mm' : 'D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'array') {
          data = value
        }
        else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.paginationList = {
          page: pagination.page,
          row: pagination.row
        }

        this.limit = pagination.row

        let params = {
          path: this.$route.fullPath,

          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        TokenService.saveFilter(JSON.stringify(this.objectReplacer(this.set_filter, params)))
        this.$store.commit("setFilter", this.objectReplacer(this.set_filter, params))

        this.selected.row = []

        await get('admin/cat/data', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Judul',
                width: '200px',
                value: 'title',
                freeze: false,
                hide: false
              },
              {
                text: 'Menu',
                width: '100%',
                value: 'menu_array',
                freeze: false,
                hide: false,
                format: 'array'
              }
            ]
            
            this.list = res.results.data
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },


      objectReplacer (arrayOfObjects, newObject) {
        let index = arrayOfObjects.findIndex((obj) => obj.path === newObject.path)

        if (index === -1) {
          arrayOfObjects.push(newObject)
        } else {
          arrayOfObjects[index] = newObject
        }

        return arrayOfObjects
      },
      objectFine () {
        let self = this

        let data = this.set_filter.filter(function(v) {
          return self.$route.fullPath == v.path
        })

        return data.length > 0 ? data[0] : []
      },


      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: ${this.set_color};
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: ${this.set_color};
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async fetchCategory () {
        this.process.category = true

        await get('admin/report/category')
        .then(response => {
          let res = response.data

          this.process.category = false
            
          if (res.status === 200) {
            this.category = res.results.data
          }
        })
      },
      async fetchUser () {
        this.process.user = true

        let params = {
          search: this.autocomplete.user
        }

        await get('admin/user', { params })
        .then(response => {
          let res = response.data

          this.process.user = false
            
          if (res.status === 200) {
            this.user = res.results.data
          }
        })
      },
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.id : '',
          title: item !== undefined ? item.title : '',
          menu_arr: []
        }

        let data = item !== undefined ? item.menu_array : []
        this.form.menu_arr = data.map(function(v) {
          return v.id
        })

        if(item !== undefined){
          for(let l in this.data_menu){
            for(let a in data){
              if(this.data_menu[l].id == data[a].id){
                this.data_menu[l].action = data[a].action
              }
            }
          }
        }

        this.picker = false

        this.process.form = false

        this.message.error = ''

        if (this.dialog.form) this.fetchCategory()
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id.length < 1 ? 'admin/cat/add' : 'admin/cat/update'

          let menu = []
          for(let l in this.data_menu){
            for(let a in this.form.menu_arr){
              if(this.data_menu[l].id == this.form.menu_arr[a]){
                menu.push(this.data_menu[l])
              }
            }
          } 

          // SAVE TO REST API
          await post(url, {
            data: {
              id: this.form.id,
              title: this.form.title,
              menu_array: menu
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      
      toDelete () {
        this.selected.delete = []

        for (let i in this.selected.row) {
          this.selected.delete.push(parseInt(this.selected.row[i].id))
        }

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('admin/cat/delete', {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          if (res.status === 200) {
            this.process.delete = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.process.delete = false
            this.message.error = res.message
          }
        })
      },

      // PRINT
      async prints () {
        this.message.error = ''

        this.process.print = true

        let params = {
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/report/export`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          if (res.status === 200) {
            this.process.print = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.xls`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.process.print = false
            this.message.error = res.message
          }
        })
      },
    }
  }
</script>

<style>
  .table-grid table thead > tr > th, .table-grid table tbody > tr > td {
    position: sticky;
    position: -webkit-sticky;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .table-grid table > tbody > tr > td:nth-child(1) {
    left: 0; 
    z-index: 1;
  }

  .table-grid table > tbody > tr:nth-of-type(even) .text-start, table > tbody > tr:nth-of-type(even) .text-center, table > tbody > tr:nth-of-type(even) .text-end {
    background: #fafafa;
  }

  .table-grid table > tbody > tr:nth-of-type(odd) .text-start, table > tbody > tr:nth-of-type(odd) .text-center, table > tbody > tr:nth-of-type(odd) .text-end {
    background: white;
  }
</style>